var _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#11041E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.257 36.1767H36.0378C36.6859 36.1767 37.2823 35.9556 37.7559 35.5848C37.8036 35.5474 37.8552 35.5152 37.9104 35.4904C40.7773 34.2047 42.7742 31.3257 42.7742 27.9803C42.7742 23.437 39.0911 19.7539 34.5477 19.7539C34.2371 19.7539 33.9305 19.7711 33.6289 19.8046C33.2672 19.8448 32.9274 19.6008 32.8493 19.2455C32.0381 15.5548 28.7488 12.793 24.8145 12.793C20.8549 12.793 17.5487 15.5905 16.7645 19.3168C16.7111 19.5703 16.4855 19.7539 16.2265 19.7539C11.6831 19.7539 8 23.437 8 27.9803C8 31.98 10.8544 35.313 14.6372 36.0534C14.8971 36.1335 15.1733 36.1767 15.4596 36.1767H15.5172C15.751 36.1966 15.9875 36.2068 16.2265 36.2068C16.4654 36.2068 16.702 36.1966 16.9357 36.1767H33.8384C34.0722 36.1966 34.3088 36.2068 34.5477 36.2068C34.7866 36.2068 35.0232 36.1966 35.257 36.1767Z",
    fill: "url(#paint0_linear_7778_9178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8843 23.5501C24.2538 22.8166 25.3009 22.8166 25.6704 23.5501L26.6627 25.5197C26.8855 25.962 27.3987 26.1746 27.8691 26.0194L29.9634 25.3283C30.7433 25.0709 31.4838 25.8114 31.2264 26.5913L30.5353 28.6856C30.3801 29.156 30.5926 29.6692 31.035 29.892L33.0046 30.8843C33.7381 31.2538 33.7381 32.3009 33.0046 32.6704L31.035 33.6627C30.5926 33.8855 30.3801 34.3987 30.5353 34.8691L31.2264 36.9634C31.4838 37.7433 30.7433 38.4838 29.9634 38.2264L27.8691 37.5353C27.3987 37.3801 26.8855 37.5926 26.6627 38.035L25.6704 40.0046C25.3009 40.7381 24.2538 40.7381 23.8843 40.0046L22.892 38.035C22.6692 37.5926 22.156 37.3801 21.6856 37.5353L19.5913 38.2264C18.8114 38.4838 18.0709 37.7433 18.3283 36.9634L19.0194 34.8691C19.1746 34.3987 18.962 33.8855 18.5197 33.6627L16.5501 32.6704C15.8166 32.3009 15.8166 31.2538 16.5501 30.8843L18.5197 29.892C18.962 29.6692 19.1746 29.156 19.0194 28.6856L18.3283 26.5913C18.0709 25.8114 18.8114 25.0709 19.5913 25.3283L21.6856 26.0194C22.156 26.1746 22.6692 25.962 22.892 25.5197L23.8843 23.5501Z",
    fill: "#DCB9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32L24 34L28 30",
    stroke: "#8F48C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7778_9178",
    x1: 20.5,
    y1: 5.99988,
    x2: 15.8184,
    y2: 35.1682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C117C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.85f5bf11f1a9eeec1fb0c00bc9e18770.svg";
export { ForwardRef as ReactComponent };